<div [ngClass]="getAlertClasses()">
    <app-icon [name]="getIconName()" [size]="20"></app-icon>
    <p class="text-sm font-medium flex-1">{{ message }}</p>

    <!-- Close button -->
    @if (closable) {
        <button 
            [ngClass]="getCloseButtonClasses()"
            (click)="handleClose()"
            aria-label="Close alert">
            <app-icon name="x" [size]="16"></app-icon>
        </button>
    }

    <!-- Progress bar at bottom -->
    @if (showProgress && duration > 0) {
        <div 
            class="absolute bottom-0 left-0 h-[3px] opacity-50 alert-progress-bar"
            [ngClass]="getProgressColor()"
            [style.animation-duration.ms]="duration">
        </div>
    }
</div>
